import {
	get, isUndefined, cloneDeep, forEach, omit, findIndex,
} from 'lodash';
import { push } from 'react-router-redux';
import utils from '@utils';
import GlobalsActions from '@redux/globals';
import AppActions from '@redux/app';
import queryString from 'query-string';

/**
 * Function to update any progressButton
 * on any redux module
 */
export const updateProgressButton = ({
	module, property, value, callback,
}) => ((dispatch) => {
	dispatch(GlobalsActions.changeState(module, property, value));

	// Prevent clean up if it's loading
	if (value === 'loading') {
		if (!isUndefined(callback)) callback();

		return;
	}

	// Clean progressButton after a 1000ms to let component finish the animation
	setTimeout(() => {
		dispatch(GlobalsActions.changeState(module, property, ''));

		if (!isUndefined(callback)) callback();
	}, 1000);
});

export const apiErrorHandler = ({
	dispatch,
	module = 'app',
	property = ['loaders', 'app'],
	usingProgressButton = false,
	defaultTitle = 'Oops',
	defaultMessage = 'Something went wrong',
}) => (error) => {
	let title = defaultTitle;
	let message = defaultMessage;

	// Use error statusText from the response as title otherwise use defaultTitle instead
	title = get(error, ['response', 'statusText'], title);

	message = get(error, 'response.data.ErrorMessage');
	message = !message ? get(error, 'response.data.Message') : message;
	message = !message ? get(error, 'response.data.message') : message;
	message = !message ? get(error, 'message') : message;
	message = !message ? get(error, 'Message') : message;

	// Fire Error Notification
	utils.notify({
		type : 'error',
		title,
		message,
	});

	if (!isUndefined(dispatch)) {
		// Stop loading animation
		if (!usingProgressButton) dispatch(GlobalsActions.changeState(module, property, false));
		else dispatch(updateProgressButton({ module, property, value : 'error' }));
	}
};

export const processUrl = (callback, omitParseQueries = []) => ((dispatch, getState) => {
	const {
		router : {
			match : { params },
			location : {
				pathname,
				search,
			},
		},
		app : {
			subName,
		},
	} = getState();
	const rawQuery = queryString.parse(search);
	const nonIntegerQueries = [
		'startDate',
		'endDate',
		'isEstimate',
		...omitParseQueries,
	];
	const dataCollection = [];
	const filtersCollection = [];

	const query = cloneDeep(rawQuery);
	/**
	 * If we change the viewType
	 * we set the query param to
	 * the initial page and push
	 * the url without the page param
	 * in order to get the first.
	 *
	 * Finally we save the last active
	 * page in order to check that in
	 * the future
	 */

	if ((params.viewType) && (subName !== params.viewType)) {
		query.pageNumber = 1;
		// Update URL
		dispatch(push({
			pathname,
			query : { ...omit(query, ['page']) },
		}));
		// Update last active page
		dispatch(AppActions.updateSubName(params.viewType));
	}

	/**
	 * Apply query params
	 * as filters including
	 * alias such as
	 * (page, and displayCount)
	 */
	forEach(query, (rawValue, key) => {
		let property;
		let value = rawValue;

		switch (key) {
			default:
				property = key;
				break;

			/**
			 * Delete default
			 * initial filters
			 * to be replaced
			 * with the query
			 * value
			 */
			case 'calendarView':
			case 'startDate':
			case 'endDate':
			case 'dateRange': {
				property = key;

				/**
				 * Get default filter
				 * index and delete it
				 */
				const filterIndex = findIndex(filtersCollection, ['property', property]);

				if (filterIndex > -1) filtersCollection.splice(filterIndex, 1);
				break;
			}
		}

		// Parse booleans
		if (value === 'true' || value === 'false') value = value === 'true';

		// Parse integers
		if (
			!nonIntegerQueries.includes(key)
			&& typeof (parseInt(value, 10) === 'number')
		) value = parseInt(value, 10);

		filtersCollection.push({ property, value });
	});

	// Reset expandedRowIds
	dataCollection.push({ property : 'expandedRowIds', value : [] });

	callback(filtersCollection, dataCollection);
});

export default {
	updateProgressButton,
	apiErrorHandler,
	processUrl,
};
